import { LocalEum } from '@/constant'
import Cookies from 'js-cookie'

// export const isInApp = typeof window !== 'undefined' ? /duapp/.test(navigator.userAgent) : false
export const isInApp =
  typeof window !== 'undefined' ? /poizon/.test(navigator.userAgent.toLowerCase()) : false

/**
 * @description 是否在App容器内
 */
export const isInAppV2 = (headers?: any) => {
  let userAgent = ''
  // 服务端渲染
  if (typeof window === 'undefined') {
    if (!headers) return
    userAgent = headers['user-agent']
  } else {
    userAgent = navigator.userAgent
  }
  return /(p|P)oizon/.test(userAgent)
}

//获取客户端传递的url中的参数值
export function getQueryString(name: string) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  let serach = ''
  if (window.location.search.length > 0) {
    serach = window.location.search.substr(1)
  } else {
    serach = window.location.href.split('?')[1] ? window.location.href.split('?')[1] : ''
  }
  const r = serach.match(reg)
  if (r != null) {
    return unescape(r[2])
  }
  return null
}

/**
 *
 * @param {需要获取的cookie的key} key
 */
export const getCookie = function (key: string, cookie?: string) {
  const cookieObj: any = {}
  let cookieSplit = []
  let cookieArr = []
  if (typeof window !== 'undefined') {
    cookieArr = document.cookie.split(';')
  } else {
    cookieArr = (cookie || '').split(';')
  }

  cookieArr.forEach((item) => {
    if (!item) return

    cookieSplit = item.split('=')
    cookieObj[cookieSplit[0].trim()] = cookieSplit[1].trim()
  })
  if (cookieObj[key]) {
    return cookieObj[key]
  } else {
    return false
  }
}

export const setCookie = function (key: string, value: any, time: any) {
  const _date = new Date()
  _date.setDate(_date.getDate() + time)
  document.cookie =
    key +
    '=' +
    value +
    (time == null ? '' : ';expires=' + time.toGMTString()) +
    ';path=/;domain=.poizon.com'
}

/**
 * 验证是否登录
 */
export const APP_ISLOGIN = function () {
  return document.cookie.includes('duToken')
}

export const debounce = function (fn: any, wait: any) {
  let timer: any = null
  return function (...args: any[]) {
    const context = this

    if (timer) {
      clearTimeout(timer)
      timer = null
    }

    timer = setTimeout(function () {
      fn.apply(context, args)
    }, wait)
  }
}

export function getUUID() {
  const s4 = () =>
    Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1)
  return `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4() + s4() + s4()}`
}

export function chunk(array: any[], size: number) {
  const length = array.length
  if (!length || !size || size < 1) {
    return []
  }
  let index = 0 //用来表示切割元素的范围start
  let resIndex = 0 //用来递增表示输出数组的下标
  const result = new Array(Math.ceil(length / size))
  while (index < length) {
    result[resIndex++] = array.slice(index, (index += size))
  }
  return result
}

/* globalscreen */
export function isIphoneX() {
  const { screen } = window
  if (typeof window !== 'undefined' && navigator.userAgent.match(/(iPhone)/)) {
    if (screen.height == 812 && screen.width == 375) {
      return true
    }
    if (screen.height == 896 && screen.width == 414) {
      return true
    }
  }
  return false
}

// 取范围内的随机数
export function randomNumber(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1)) + min
}

/*
 * 控制图片的尺寸
 *
 * @param { url string } 原始 url
 * @param { width number } 图片宽度
 *
 * @return string 增强后的图片 url
 */
export function enhanceImgUrlWithWidth(url: string, width: number) {
  if (!url || !width) {
    return url
  }
  const pre = url.indexOf('?') > -1 ? '&' : '?'
  return `${url}${pre}x-oss-process=image/resize,w_${width}&imageView2/2/w/${width}`
}

/*
 * 处理价格数值
 *
 * @param { val number } 单位为分的价格数据
 * @return string 单位为元的价格数据
 */
export function processPrice(val: any) {
  if (!val) {
    return '--'
  }
  if (val < 100) {
    return 1
  }
  const tmp = val.toString()
  return tmp.substr(0, tmp.length - 2)
}

export function dateFormat(fmt: any, date: any) {
  let ret
  const opt: any = {
    'Y+': date.getFullYear().toString(), // 年
    'm+': (date.getMonth() + 1).toString(), // 月
    'd+': date.getDate().toString(), // 日
    'H+': date.getHours().toString(), // 时
    'M+': date.getMinutes().toString(), // 分
    'S+': date.getSeconds().toString(), // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  }
  for (const k in opt) {
    ret = new RegExp('(' + k + ')').exec(fmt)
    if (ret) {
      fmt = fmt.replace(ret[1], ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'))
    }
  }
  return fmt
}

/**
 * 判断是否处于iPhone浏览器
 * @returns Boolean
 */
export function getIsIphone() {
  return typeof window !== 'undefined' ? navigator.userAgent.match(/(iPhone)/) : false
}

// 把obj解析为query

export function obj2query(obj: any, needEncode = false) {
  const str = Object.keys(obj)
    .map((key) => {
      return `${key}=${needEncode ? encodeURIComponent(obj[key]) : obj[key]}`
    })
    .join('&')

  return str
}

/**
 * 创建一个hash
 * @param hashLength
 */
export function createHash(hashLength = 24) {
  // 默认长度 24
  return Array.from(Array(Number(hashLength) || 24), () =>
    Math.floor(Math.random() * 36).toString(36)
  ).join('')
}

export const copyText = function (text) {
  const input = document.createElement('input')
  input.setAttribute('readonly', 'readonly')
  input.setAttribute('value', text)
  input.style.opacity = '0'
  document.body.appendChild(input)
  input.select()
  input.setSelectionRange(0, 9999)
  return new Promise((resolve, reject) => {
    if (document.execCommand('copy')) {
      resolve()
    } else {
      // eslint-disable-next-line prefer-promise-reject-errors
      reject()
    }
    document.body.removeChild(input)
  })
}

interface Query {
  [key: string]: any
}

export function getQueryParams(urlStr?: string): Query {
  let url = urlStr || '' //获取url中"?"符后的字串
  if (typeof window !== 'undefined') {
    url = location.href
  }

  const search = url.split('?')[1]
  if (search) {
    const strs = search.split('&')
    const p = strs.reduce((pre, cur) => {
      const [key, value] = cur.split('=')
      return { ...pre, [key]: unescape(value) }
    }, {} as Query)
    return p
  }
  return {}
}

function toThousands(number: number): string {
  let num = (number || 0).toString(),
    result = ''
  while (num.length > 3) {
    result = ',' + num.slice(-3) + result
    num = num.slice(0, num.length - 3)
  }
  if (num) {
    result = num + result
  }
  return result
}
// 这里用于统一处理 price 问题

// 开发日期： 2021/10/13， 在此之前的代码请逐渐规范到这里

// region 的获取方案，请逐渐统一，目前获取路径为cookie + params方式获取

function getRegion() {
  const cookiRegion = Cookies.get('region')
  const searchRegion = location.pathname.split('/')[4]
  return searchRegion || cookiRegion || searchRegion
}

// 需要位置获取
let region

// 通过既定的区域设置价格
/**
 * 策略1: 后端目前返回的数据全部为Lang类型，但是对于日元来说，后端没有精确到钱分位
 */
export const formatMoney = (price: any, isThousands?: boolean) => {
  if (!region) {
    region = getRegion()
  }
  const reg = /(\d{1,3})(?=(\d{3})+(?:$|\.))/g
  if (!price || price === 0 || price === '0') {
    return '--'
  }
  if (region === 'JP' || region === 'KR') {
    return isThousands ? `${price}`.replace(reg, '$1,') : price
  }

  return isThousands ? `${Number(price / 100)}`.replace(reg, '$1,') : price / 100
}
